/**
 * @generated SignedSource<<0dfeb30fd457234383159c0d01143394>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentShareWidgetContent$data = {
  readonly entityId: string;
  readonly headline: string | null;
  readonly shortUrl: string | null;
  readonly socialHeadline: string | null;
  readonly urlAlias: string;
  readonly " $fragmentType": "contentShareWidgetContent";
};
export type contentShareWidgetContent$key = {
  readonly " $data"?: contentShareWidgetContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"contentShareWidgetContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contentShareWidgetContent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlAlias",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shortUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "socialHeadline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headline",
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "a50d67032a99865d17143adf4c567583";

export default node;
